import { Link, useParams } from "react-router-dom";
import { UserGroup } from "./types";
import DeleteWithConfirm from "./DeleteWithConfirm";
import { useQueryClient } from '@tanstack/react-query';
import { isOwner } from "@/services/auth";
import { Button, Stack, Tooltip } from "@altimateai/lego";
import { IconAlertTriangle } from "@tabler/icons-react";
import { useAppState } from "@/modules/app/useAppContext";

interface Props {
  group: UserGroup;
}

const UserGroupItem = ({ group }: Props) => {
  const { id } = useParams();
  const { enableCostAttributionInTeams } = useAppState();
  const queryClient = useQueryClient();
  const refetch = () => {
    queryClient.invalidateQueries({ queryKey: ["UserGroups"] });
  };

  const canDelete = group.is_owner ? false : isOwner();
  const isActive = `${group.id}` === id;
  return (
    <Button
      asChild
      variant="ghost"
      key={group.id}
      className={`al-border-0 ${isActive ? "al-bg-gray-15" : "al-bg-gray-10"} al-w-full al-mb-2 !al-justify-start al-font-normal al-text-gray`}
    >
      <Link to={`/usergroups/${group.id}`}>
        <Stack justify="between" align="start">
          <Stack direction="row" align="center" gap="xs">
            {group.name}
            {enableCostAttributionInTeams && group.has_conflicts && (
              <Tooltip title="Has ownership conflicts">
                <IconAlertTriangle size={14} className="al-text-yellow-600" />
              </Tooltip>
            )}
          </Stack>
          <span className="d-none">
            {canDelete ? (
              <DeleteWithConfirm
                entityId={group.id}
                id=""
                refetch={refetch}
                entityType="usergroup"
                title={`Delete team ${group.name}`}
              />
            ) : null}
          </span>
        </Stack>
      </Link>
    </Button>
  );
};

export default UserGroupItem;
